module.exports = __webpack_public_path__ + "static/media/grupoAmerica.3aed56c2.svg";